import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../../components/ui/DashboardLayout';
import { devURL } from '../../../utils';
import Loading from '../../../components/ui/Loading';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Copy } from '../../../components/ui/Swicons';
import { toast } from 'react-toastify';
import { FaArrowRight } from 'react-icons/fa6';

export default function Invite() {
  const token = localStorage.getItem('swToken');
  const [referralCode, setReferralCode] = useState('');
  const [limit, setLimit] = useState('');
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    axios
      .get(`${devURL}/user/get-user-info`, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data) {
          axios
            .get(`${devURL}/referral/generat/${res.data._id}`, {
              headers: { token: token },
            })
            .then((res) => {
              setReferralCode(res.data.referral_code);
              setLimit(res.data.refer_limit);
              setLoader(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <DashboardLayout>
      <div className='page-title text-xl font-bold'>
        <h1>Referral Reward System</h1>
      </div>
      <div className='my-10 flex items-center justify-center'>
        {loader ? (
          <Loading />
        ) : (
          <div className='bg-white px-3 py-6 shadow-lg rounded-sm justify-center sw-shadow w-3/4 xl:w-2/5 m-2 ml-4 lg:ml-0'>
            {limit <= 0 ? (
              <div className='page-title text-4xl font-bold my-4'>
                You have reached your referral limit.
              </div>
            ) : (
              <div>
                <div className='flex justify-center text-xl mt-4'>
                  Send the referral code provided below to your friends:
                </div>
                <div className='flex justify-center text-xl font-bold mt-4'>
                  <div className='page-title p-4 shadow-xl border-t-2 border-r-2  border-l-2 rounded-xl flex'>
                    <div>{referralCode}</div>
                    <div className='pl-4'>
                      <CopyToClipboard
                        text={referralCode}
                        onCopy={() => toast.success('Copied!')}
                      >
                        <button style={{ marginTop: '1px' }}>
                          <Copy />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
                <div className='flex justify-center text-xl mt-6'>
                  Number of friends you can invite:
                </div>
                <div className='page-title text-4xl font-bold mt-4'>
                  {limit}
                </div>
                <hr className='mb-8 mt-6 border-t-2 border-gray-300' /> {/* Horizontal line added here */}
                <div className='flex justify-center items-center text-xl mt-8 px-8'>
                  <div>
                    When a referred friend registers and spends a minimum of{' '}
                    <span className='text-themeColor font-bold'>€100</span>
                  </div>
                  <div className='pr-8'>
                    <FaArrowRight />
                  </div>
                  <div>
                    You will receive a promo code worth{' '}
                    <span className='text-themeColor font-bold'>€10</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
